

































import { defineComponent } from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import WarningCard from '@front-app/components/cards/state/WarningCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import BaseGroupPageColumn from './BaseGroupPageColumn.vue';

export default defineComponent({
	components: { BaseGroupPageColumn, WarningCard, CtaButton },
	setup(props, ctx) {
		return {
			Size,
			ButtonPalettes,
			logOut: () => CurrentUserStore.actions.logOut(ctx.root.$route, ctx.root.$router, ctx.root.$route.fullPath),
		};
	},
});
